import { graphql, useStaticQuery } from 'gatsby';

export interface ISiteMetaData {
  title: string;
  description: string;
  twitterUsername: string;
  twitterSummaryLargeImage: string;
  image: string;
  siteUrl: string;
}
export const useSiteMetadata = () => {
  const data = useStaticQuery<{
    site: {
      siteMetadata: ISiteMetaData;
    };
  }>(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          twitterUsername
          twitterSummaryLargeImage
          image
          siteUrl
        }
      }
    }
  `);

  return data.site.siteMetadata;
};
